import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styles: []
})

export class HeaderComponent implements OnInit {
    public showMenu = true;
    public navSub: any;

    constructor(public router: Router) {
        this.navSub = router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.showMenu = false;
            }
        }, error => {
            console.log(error);
        });
    }

    ngOnInit() {
    }

    toggleMenu() {
        this.showMenu = !this.showMenu;
        console.log(this.showMenu);
    }
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/header/header.component.ts